// the sections of the form in the order of the paper form (there is no section V)
export const SECTION_STEPS = [
  { key: "pengajuan", code: "I", label: "Pengajuan" },
  { key: "analisis", code: "II", label: "Analisis" },
  { key: "pembelian", code: "III", label: "Pembelian" },
  { key: "penerimaan", code: "IV", label: "Penerimaan" },
  { key: "kelengkapan", code: "VI", label: "Kelengkapan" },
];

const circleClass = {
  done: "bg-emerald-500 text-white",
  active: "bg-white text-indigo-600 border-2 border-indigo-500",
  pending: "bg-slate-100 text-slate-400",
  cancelled: "bg-red-100 text-red-500",
};

const lineClass = (stage) =>
  stage === "done" ? "bg-emerald-400" : "bg-slate-200";

/**
 * Progress of the request: one step per section, click a step to open its section.
 */
const PermintaanMinyakStepper = ({ stages, openSection, onSelect }) => {
  return (
    <div className="elevated-card-tight-vertical row-between-start w-full !px-4 sm:!px-6">
      {SECTION_STEPS.map((step, index) => {
        const stage = stages[step.key];
        const isOpen = openSection === step.key;

        return (
          <div
            key={step.key}
            className={`row-start-start ${
              index < SECTION_STEPS.length - 1 ? "flex-1" : ""
            }`}
          >
            <button
              type="button"
              className="col-start-center gap-1 bg-transparent border-none cursor-pointer p-0"
              onClick={() => onSelect(step.key)}
              aria-label={`${step.code}. ${step.label}`}
            >
              <span
                className={`row-center-center h-8 w-8 rounded-full text-sm font-bold ${
                  circleClass[stage]
                } ${isOpen ? "ring-2 ring-indigo-200" : ""}`}
              >
                {stage === "done" ? (
                  <i className="pi pi-check text-xs" />
                ) : stage === "cancelled" ? (
                  <i className="pi pi-times text-xs" />
                ) : (
                  step.code
                )}
              </span>
              <span
                className={`hidden text-xs sm:block ${
                  isOpen ? "font-bold text-indigo-600" : "text-slate-500"
                }`}
              >
                {step.label}
              </span>
            </button>
            {index < SECTION_STEPS.length - 1 && (
              <div
                className={`mt-4 mx-2 h-[2px] flex-1 ${lineClass(stage)}`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PermintaanMinyakStepper;
